import {
  handleRequest,
  handleMultiRequest,
} from "@/store/utils/requestFunctions";
import * as endpoints from "@/store/constants/endpoints";
import * as types from "./mtypes";
import axios from "axios";

export default {
  async getAllRoles({ commit }, query) {
    await handleMultiRequest(
      commit,
      (params) =>
        axios.get(`${endpoints.ROLES}${query}`, { params: { ...params } }),
      types.FETCH_ALL_ROLES_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  //Roles
  async getRoles({ commit }, params) {
    await handleRequest(
      commit,
      () => axios.get(`${endpoints.ROLES}${params}`),
      types.FETCH_ROLES_SUCCESS,
      types.FETCH_ROLES_FAILURE,
    );
  },

  async getRole({ commit }, id) {
    await handleRequest(
      commit,
      () => axios.get(`${endpoints.ROLES}/${id}`),
      types.FETCH_ONE_ROLE_SUCCESS,
      types.FETCH_ROLES_FAILURE,
    );
  },

  async addRole({ commit }, role) {
    await handleRequest(
      commit,
      () => axios.post(`${endpoints.ROLES}`, role),
      types.REQUEST_SUCCESS,
      types.FETCH_ROLES_FAILURE,
    );
  },

  async updateRole({ commit }, role) {
    await handleRequest(
      commit,
      () => axios.put(`${endpoints.ROLES}`, role),
      types.REQUEST_SUCCESS,
      types.FETCH_ROLES_FAILURE,
    );
  },
  //End Roles

  async AddRolesToUser({ commit }, instance) {
    await handleRequest(
      commit,
      () => axios.put(`${endpoints.USERS}${endpoints.ROLES}/add`, instance),
      types.REQUEST_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  async RemoveRolesToUser({ commit }, instance) {
    await handleRequest(
      commit,
      () => axios.put(`${endpoints.USERS}${endpoints.ROLES}/remove`, instance),
      types.REQUEST_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  async AddPermissionsToRole({ commit }, instance) {
    await handleRequest(
      commit,
      () =>
        axios.put(`${endpoints.ROLES}${endpoints.PERMISSIONS}/add`, instance),
      types.REQUEST_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  async RemovePermissionsToRole({ commit }, instance) {
    await handleRequest(
      commit,
      () =>
        axios.put(
          `${endpoints.ROLES}${endpoints.PERMISSIONS}/remove`,
          instance,
        ),
      types.REQUEST_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  async getPermissions({ commit }, query) {
    commit(types.FETCH_ROLES_REQUEST);

    try {
      const response = await axios.get(`/Permissions${query}`);
      if (response.data.succeeded) {
        commit(types.FETCH_ALL_PERMISSIONS_SUCCESS, response.data.data);
      } else {
        commit(types.FETCH_ALL_PERMISSIONS_FAILURE, response.data.errorMessage);
      }
    } catch (error) {
      commit(types.FETCH_ALL_PERMISSIONS_FAILURE, error);
    }
  },
};
